import styled, { css } from 'styled-components'
import { getAutomatedStyleProp } from '../../providers/ComponentsThemeProvider'

export const Container = styled.div<{
  $size: 'small' | 'medium' | 'large'
}>`
  & + & {
    border-top: 1px solid ${getAutomatedStyleProp('pale', 'var(--border-tertiary)')};

    ${({ $size }) =>
      $size === 'small' &&
      css`
        margin-top: var(--space-200);
        padding-top: var(--space-200);
      `}

    ${({ $size }) =>
      $size === 'medium' &&
      css`
        margin-top: var(--space-400);
        padding-top: var(--space-400);
      `}

    ${({ $size }) =>
      $size === 'large' &&
      css`
        margin-top: var(--space-600);
        padding-top: var(--space-600);
      `}
  }
`
